(() => {
  const form = document.getElementById('Anam-Search-Form');
  const panel = document.getElementById('Anam-Scoped-Results');
  if (!form || !panel || form.dataset.bound) return;
  form.dataset.bound = 'true';
  const main = document.getElementById('MainContent');
  if (!main) return;
  main.prepend(panel);
  const input = form.querySelector('[name="q"]');
  const scope = document.getElementById('Anam-Search-Scope');
  const cleanTerm = value => {
    if (!value.startsWith('title:')) return value;
    try { return value.split(' AND ').map(part => JSON.parse(part.slice(6))).join(' '); } catch { return value; }
  };
  document.querySelectorAll('form[role="search"] input[name="q"]').forEach(field => { field.value = cleanTerm(field.value); });
  document.addEventListener('submit', event => {
    const target = event.target;
    if (!(target instanceof HTMLFormElement) || target.getAttribute('role') !== 'search') return;
    if (target === form && scope.value === 'collection') return;
    const field = target.querySelector('[name="q"]');
    if (!field) return;
    event.preventDefault();
    event.stopPropagation();
    const term = field.value.trim();
    if (!term) { field.focus(); return; }
    location.assign(globalUrl(term).href);
  }, true);
  const globalUrl = term => {
    const url = new URL(form.dataset.allProductsUrl, location.origin);
    url.searchParams.set('anam_q', term);
    url.searchParams.set('anam_scope', 'all');
    return url;
  };
  const currentSearch = new URL(location.href);
  form.addEventListener('reset', () => {
    if (!currentSearch.searchParams.has('anam_q')) return;
    const url = new URL(location.href);
    url.searchParams.delete('anam_q');
    url.searchParams.delete('anam_scope');
    url.searchParams.delete('page');
    location.assign(url.href);
  });
  if (currentSearch.pathname === new URL(form.action).pathname && currentSearch.searchParams.get('q')) {
    location.replace(globalUrl(cleanTerm(currentSearch.searchParams.get('q'))).href);
    return;
  }
  form.addEventListener('submit', (event) => {
    if (scope.value !== 'collection') return;
    event.preventDefault();
    const term = input.value.trim();
    if (!term) { input.focus(); return; }
    const url = new URL(form.dataset.collectionUrl, location.origin);
    url.searchParams.set('anam_q', term);
    location.assign(url.href);
  }, true);
  const term = currentSearch.searchParams.get('anam_q') || '';
  const listingAll = !term && currentSearch.pathname.replace(/\/$/, '') === new URL(form.dataset.allProductsUrl, location.origin).pathname.replace(/\/$/, '');
  if (!term && !listingAll) return;
  const withinCollection = Boolean(form.dataset.collectionUrl && scope.querySelector('[value="collection"]') && currentSearch.searchParams.get('anam_scope') !== 'all');
  scope.value = withinCollection ? 'collection' : 'all';
  input.value = term;
  if (term) form.querySelector('[type="reset"]')?.classList.remove('hidden');
  main.classList.add('anam-scoped-mode');
  panel.hidden = false;
  const heading = panel.querySelector('h1');
  heading.textContent = listingAll ? scope.querySelector('[value="all"]').textContent : (withinCollection ? form.dataset.collectionTitle : scope.querySelector('[value="all"]').textContent) + '：' + term;
  const status = document.getElementById('Anam-Scoped-Status');
  const link = document.getElementById('Anam-Scoped-Global');
  link.hidden = !withinCollection;
  link.href = globalUrl(term).href;
  link.textContent = panel.dataset.global;
  status.textContent = panel.dataset.loading;
  panel.setAttribute('aria-busy', 'true');
  const normalize = value => value.normalize('NFKC').toLocaleLowerCase().replace(/[ァ-ヶ]/g, c => String.fromCharCode(c.charCodeAt(0) - 0x60));
  const terms = normalize(term).trim().split(/\s+/).filter(Boolean);
  const grid = document.getElementById('Anam-Scoped-Grid');
  const more = document.getElementById('Anam-Scoped-More');
  more.textContent = panel.dataset.more;
  let matches = [];
  let shown = 0;
  function showMore() {
    for (const product of matches.slice(shown, shown + 24)) {
      const item = document.createElement('li');
      const a = document.createElement('a');
      a.href = product.url;
      if (product.image) { const img = document.createElement('img'); img.src = product.image; img.alt = product.title; img.loading = 'lazy'; img.width = 600; img.height = 600; a.append(img); }
      const title = document.createElement('h2'); title.textContent = product.title; a.append(title);
      const price = document.createElement('p'); price.textContent = product.price + (product.priceVaries ? '〜' : ''); a.append(price);
      if (!product.available) { const sold = document.createElement('p'); sold.textContent = panel.dataset.soldout; a.append(sold); }
      item.append(a); grid.append(item);
    }
    shown = Math.min(shown + 24, matches.length);
    more.hidden = shown >= matches.length;
  }
  more.addEventListener('click', showMore);
  async function run() {
    try {
      const seen = new Set();
      let expectedTotal = null;
      const fetchPage = async page => {
        const url = new URL(withinCollection ? form.dataset.collectionUrl : form.dataset.allProductsUrl, location.origin);
        url.searchParams.set('view', 'anam-search-data');
        if (listingAll) url.searchParams.set('sort_by', currentSearch.searchParams.get('sort_by') || 'created-descending');
        url.searchParams.set('page', String(page));
        const response = await fetch(url.href, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Search data unavailable');
        const data = await response.json();
        if (!Array.isArray(data.products) || Number(data.page) !== page || !Number.isInteger(data.pages) || data.pages < 0 || data.total > 25000) throw new Error('Incomplete search data');
        return data;
      };
      const consume = data => {
        if (expectedTotal === null) expectedTotal = data.total;
        if (data.total !== expectedTotal) throw new Error('Catalog changed during search');
        for (const product of data.products) {
          if (seen.has(product.id)) continue;
          seen.add(product.id);
          if (product.hidden === true) continue;
          const title = normalize(product.title);
          if (terms.every(word => title.includes(word))) matches.push(product);
        }
      };
      const first = await fetchPage(1);
      consume(first);
      for (let page = 2; page <= first.pages; page += 3) {
        const batch = [];
        for (let next = page; next <= Math.min(page + 2, first.pages); next++) batch.push(fetchPage(next));
        for (const data of await Promise.all(batch)) consume(data);
      }
      if (seen.size !== expectedTotal) throw new Error('Incomplete product list');
      matches.sort((a, b) => Number(b.available) - Number(a.available));
      status.textContent = matches.length ? panel.dataset.count.replace('__COUNT__', String(matches.length)) : panel.dataset.empty;
      showMore();
    } catch (error) {
      matches = [];
      status.textContent = panel.dataset.error;
    } finally { panel.removeAttribute('aria-busy'); }
  }
  run();
})();
